import React from "react";
import Logo from "../assets/Logo.svg";

const NavBar = () => {
  return (
    <>
      <nav className="w-full mx-auto pt-5 md:pt-16 block bg-whiteExtra flex justify-center font-guton">
        <div className="w-90 flex justify-between items-center max-w-[1440px]">
          <a href="/" className="flex items-center">
            <img src={Logo} alt="Logo" className="h-7 md:h-10 lg:h-16" />
          </a>
          <div className="flex space-x-8 items-center">
            <div className="hidden md:flex space-x-4 lg:space-x-8">
            <a href="/services" className="font-Regular text-14 md:text-16 lg:text-20 xl:text-25">Services</a>
            <a href="/poland" className="font-Regular text-14 md:text-16 lg:text-20 xl:text-25">Poland</a>
            <a href="/aboutus" className="font-Regular text-14 md:text-16 lg:text-20 xl:text-25">About Us</a>
            </div>
            <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton font-bold bg-custom-gradient text-white py-2 px-3 md:py-[5px] xl:py-2 rounded-full text-14 lg:text-20 md:px-4 lg:px-6 xl:text-25 xl:px-6 hover:bg-black hover:bg-custom-hover-gradient transition duration-500 ease-in-out">Start Your Journey</a>
            
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
